<template>
  <div class="wrapper_create_roles">
    <div class="top">
      <v-form ref="form" v-model="valid" lazy-validation>
        <div class="inputName">
          <label>{{
            localStorage.translations.pages['setting-roles'].labels['nazvanie-roli']
          }}</label>
          <transition name="fade" mode="out-in">
            <v-skeleton-loader
              v-if="routeRolesUpdate && !roleData"
              height="76px"
              type="list-item"
            />
            <v-text-field
              v-else
              outlined
              class="name_roles"
              v-model="checkData.name"
              :rules="[inputRules.required]"
            ></v-text-field>
          </transition>
        </div>
      </v-form>
      <RolesColorPickerBtn
        :name="checkData.name"
        :textColor="checkData.textColor"
        @onColorPick="onColorPick"
        :backColor="roleData ? roleData.back_color : null"
      />
      <div class="textColor">
        <label>{{
          localStorage.translations.pages['setting-roles'].labels['vyberite-tsvet-teksta']
        }}</label>
        <div class="grid">
          <button
            class="color_text color_text_black"
            :class="{ active: checkData.textColor === '#2C2C2C' }"
            @click="checkData.textColor = '#2C2C2C'"
          ></button>
          <button
            class="color_text color_text_white"
            :class="{ active: checkData.textColor === '#ffffff' }"
            @click="checkData.textColor = '#ffffff'"
          ></button>
        </div>
      </div>
    </div>
    <div class="mid">
      <h4>
        {{
          localStorage.translations.pages['setting-roles']['access-types'][
            'nastroyka-tipov-dostupov'
          ]
        }}
      </h4>
      <v-expansion-panels v-model="panel" multiple accordion class="mid_panels">
        <v-expansion-panel v-for="(item, key) in rolesConfig" :key="'expansion-panel_' + key">
          <v-expansion-panel-header>{{ item.title }}</v-expansion-panel-header>
          <v-expansion-panel-content
            v-for="(param, paramKey) in item.params"
            :key="'expansion-panel-content_' + paramKey"
          >
            <div class="item">
              {{ param.name }}
              <v-select
                class="selectCustom"
                outlined
                dense
                height="46px"
                v-model="abilities[key + '_' + paramKey]"
                :items="param.list"
                append-icon="fas fa-angle-down"
                menu-props="offset-y"
                hide-details
              ></v-select>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <div class="fixedBtn">
        <BaseTooltip
          :tooltip="localStorage.translations.pages['setting-roles'].buttons.sohranit"
          max-content
        >
          <BaseButton
            @click="createUpdateRole"
            round
            size="60"
            icon_only
            default_icon="button-save"
            class="mt-2"
          />
        </BaseTooltip>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import RolesColorPickerBtn from 'components/setting/roles/RolesColorPickerBtn'
import roles_config from '~/configs/setting/roles'

export default {
  name: 'rolesCreateUpdate',
  components: { RolesColorPickerBtn },
  data: () => ({
    panel: [],
    valid: false,
    radios: 'radio-1',
    activeColor: 'black',
    abilitiesName: [],
    checkData: {
      name: '',
      backColor: '#FFFF00FF',
      textColor: '#2C2C2C',
    },
    abilities: {},
  }),
  created() {
    this.listOfAbilities()
    if (this.routeRolesUpdate) {
      this.showRole(this.$route.params.id)
    } else {
      this.onActualData()
    }
  },
  watch: {
    checkData: {
      handler(val) {
        this.onNavigationGuardianCheck({
          data: {
            role: this.checkData,
          },
          overwrite: false,
        })
      },
      deep: true,
    },
    abilities: {
      handler(val) {
        this.onNavigationGuardianCheck({
          data: {
            abilities: this.abilities,
          },
          overwrite: false,
        })
      },
      deep: true,
    },
    roleData() {
      this.onActualData()
    },
  },
  computed: {
    ...mapGetters(['inputRules']),
    ...mapGetters('commonRole', ['abilitiesData', 'roleData']),
    ...mapGetters('navigationGuardian', ['navigationGuardianActive']),
    ...mapGetters('user', ['userType']),
    dataAbilityName() {
      return this.roleData.abilities ? this.roleData.abilities[0].ability_name : null
    },
    routeRolesUpdate() {
      return this.$route.name === 'SettingRolesUpdate'
    },
    rolesConfig() {
      return roles_config
    },
  },
  methods: {
    ...mapActions('user', ['getUser']),
    ...mapActions('commonRole', ['listOfAbilities', 'CreateRole', 'UpdateRole', 'showRole']),
    ...mapMutations('commonRole', ['setRoleData']),
    ...mapActions('navigationGuardian', [
      'onNavigationGuardianCheck',
      'offNavigationGuardianCheck',
    ]),
    async onActualData() {
      if (Object.keys(this.roleData).length) {
        this.checkData.name = this.roleData.role_name
        this.checkData.textColor = this.roleData.text_color
        this.checkData.backColor = this.roleData.back_color
        await this.onAbilitiesName()
      }
      for (let itemKey in this.rolesConfig) {
        const item = this.rolesConfig[itemKey]
        for (let paramKey in item.params) {
          const param = item.params[paramKey]
          let accesses = []
          this.$set(this.abilities, itemKey + '_' + paramKey, [])
          for (let accessKey in param.accesses) {
            if (Array.isArray(param.accesses[accessKey])) {
              accesses.push(...param.accesses[accessKey])
            }
          }
          if (accesses.length) {
            this.onCheckAbilities(accesses, this.abilities[itemKey + '_' + paramKey])
          }
        }
      }
      this.onNavigationGuardianCheck({
        data: { role: this.checkData, abilities: this.abilities },
        overwrite: true,
      })
    },
    onColorPick(value) {
      return (this.checkData.backColor = value)
    },
    validate() {
      return this.$refs.form.validate()
    },
    onAbilitiesName() {
      let abilitiesName = []
      for (let i = 0; i < this.roleData.abilities.length; i++) {
        abilitiesName.push(this.roleData.abilities[i].ability_name)
      }
      this.abilitiesName = [...new Set(abilitiesName)]
    },
    onCheckAbilities(abilitiesList, target) {
      if (this.abilitiesName.length) {
        for (let i = 0; i < abilitiesList.length; i++) {
          if (this.abilitiesName.includes(abilitiesList[i])) {
            target.push(abilitiesList[i])
          }
        }
      }
    },
    async createUpdateRole() {
      if (this.validate()) {
        if (this.navigationGuardianActive) {
          let data = {
            language_id: $cookies.get('languageSelect').id,
            id: this.$route.params.id,
            role_name: this.checkData.name,
            text_color: this.checkData.textColor,
            back_color: this.checkData.backColor,
            abilities: Object.values(this.abilities).flat(Infinity),
          }
          this[this.$route.name === 'SettingRolesCreate' ? 'CreateRole' : 'UpdateRole']({ data })
            .then(async (response) => {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message:
                    this.localStorage.translations.pages.common.notifications[
                      this.$route.name === 'SettingRolesCreate'
                        ? 'uspeshno-cozdano'
                        : 'izmeneniya-uspeshno-sohraneny'
                    ],
                  IsError: false,
                },
                { root: true },
              )
              if (this.$route.name === 'SettingRolesUpdate' && this.userType !== 'superadmin') {
                this.getUser()
              }
              await this.offNavigationGuardianCheck()
              this.$router.push({ name: 'SettingRoles' })
            })
            .catch((err) => {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message:
                    this.localStorage.translations.pages.common.notifications[
                      err.response.data.role_name ? 'name_is_already_in_use' : 'oshibka'
                    ],
                  IsError: true,
                },
                { root: true },
              )
            })
        } else {
          this.$router.push({ name: 'SettingRoles' })
        }
      }
    },
  },
  destroyed() {
    this.setRoleData()
  },
}
</script>

<style lang="scss" scoped>
.wrapper_create_roles {
  padding: 30px 60px;
  h4 {
    font-weight: normal;
    font-size: 24px;
    line-height: 148%;
    color: #2c2c2c;
    margin: 31px 0px 30px 0px;
  }
  label {
    font-weight: normal;
    font-size: 14px;
    line-height: 26px;
    color: #52525f;
  }
  .v-expansion-panels {
    z-index: 0;
  }
  :deep() .inputName {
    .v-skeleton-loader {
      width: 220px;
      &__list-item {
        padding: 0;
        .v-skeleton-loader__text {
          height: 100%;
        }
      }
    }
    .name_roles {
      .v-input__slot {
        min-height: 46px;
      }

      box-sizing: border-box;
      border-radius: 4px;
      &.v-input--is-focused {
        fieldset {
          color: #2c2c2c;
        }
      }
      &.v-input--is-label-active {
        fieldset {
          color: #26bc2c !important;
        }
      }

      &:hover {
        fieldset {
          color: #2c2c2c;
        }
      }
    }
  }
  .top {
    display: grid;
    grid-template-columns: auto auto auto;
    grid-column-gap: 60px;
    width: max-content;
    .textColor {
      display: grid;
      grid-template-rows: max-content;
      grid-row-gap: 10px;
      .grid {
        display: grid;
        grid-template-columns: auto auto;
        grid-column-gap: 10px;
        justify-content: flex-start;
        .color_text {
          width: 30px;
          height: 30px;
          border-radius: 8px;
          border: 2px solid #dddada;
          position: relative;
          &_white {
            background-color: white;
          }
          &_black {
            background-color: black;
          }
          &::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: calc(100% + 10px);
            height: calc(100% + 10px);
            border-radius: 8px;
            transition: 0.3s;
            border: 2px solid transparent;
          }
          &:hover {
            &::before {
              border: 2px solid #6ab1d8;
            }
          }
          &.active {
            &::before {
              border: 2px solid #277faf;
            }
          }
        }
      }
    }
  }
  :deep().mid {
    &_panels {
      display: grid;
      grid-template-columns: 1fr 1fr;
      align-items: start;
      align-content: start;
      grid-column-gap: 20px;
      grid-row-gap: 20px;
      @media screen and (min-width: 2300px) {
        grid-template-columns: 1fr 1fr 1fr;
      }
      .v-expansion-panel-header {
        font-weight: 500;
        font-size: 20px;
        line-height: 36px;
        color: #2c2c2c;
        transition: all 0.3s;
        &--active {
          background: #277faf;
          color: #ffffff;
          .v-icon {
            color: #ffffff !important;
          }
          &:hover {
            background: #16558f;
          }
        }
        &:hover {
          background: #277faf;
          color: #ffffff;
          .v-icon {
            color: #ffffff;
          }
        }
      }
      .v-expansion-panel-content {
        &__wrap {
          padding: 24px;
          border-top: 1px solid #dcecf5;
        }
        .item {
          display: grid;
          grid-template-columns: 200px auto;
          font-weight: normal;
          font-size: 20px;
          line-height: 36px;
          color: #48525d;
          align-items: center;
          align-content: center;
          .v-input__slot {
            margin: 0;
          }
          .v-select__selection--comma {
            white-space: normal;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.wrapper_create_roles {
  .v-input__append-inner {
    height: 100%;
    width: 46px;
    background-color: #277faf;
    margin-top: 0px !important;
    display: flex;
    align-items: center;
    i {
      color: #ffffff !important;
      font-size: 15px;
    }
  }
  .v-menu__content {
    border-radius: 0px !important;
    .v-list {
      padding: 0px;
    }
  }
  .v-list-item__content {
    font-size: 14px;
    line-height: 16px;
    color: #2c2c2c;
  }
}
</style>
